$(document).ready(() => { 
    $('#header_language_list select').on('change', function(){
        let value = $(this).val();
        window.location.replace(value);
    });
});